var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDvf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.61 15.015 19.992 4.391a1.332 1.332 0 0 0-1.885 0l-6.224 6.229-1.802-1.804a1.336 1.336 0 0 0-1.887 0L1.39 15.622c-.52.521-.52 1.365 0 1.89l6.806 6.81c.52.52 1.364.52 1.889 0l1.191-1.193-5.007-5.008a1.334 1.334 0 0 1-.001-1.885l.275-.277 11.559 11.566c.52.52 1.364.52 1.884 0L30.606 16.9a1.33 1.33 0 0 0 .004-1.885z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvf);
export default __webpack_public_path__ + "static/media/DVF.53ebae65f45618c256bab036f514407f.svg";
export { ForwardRef as ReactComponent };